import React from 'react';
import { Box, Typography } from '@mui/material';
import { useServerLocalClock } from '../../hooks/useServerLocalClock';

interface DateTimeDisplayProps {
  isHorizontal?: boolean;
}

/**
 * Fecha y hora en layout horizontal (misma forma i18n que el header vertical).
 * Ej.: "Vie 07 Ago 26 · 18:49:55" / "Fri 07 Aug 26 · 18:49:55"
 */
const DateTimeDisplay: React.FC<DateTimeDisplayProps> = ({ isHorizontal = false }) => {
  const { compactLabel } = useServerLocalClock({ enabled: isHorizontal });

  if (!isHorizontal) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginRight: 1.5,
        color: '#fff',
        flexShrink: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: '0.75rem',
          fontWeight: '500',
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {compactLabel}
      </Typography>
    </Box>
  );
};

export default DateTimeDisplay;
